export enum DumpTypeEnum {
    CONTEXT_APP = 'app',
    CONTEXT_APP_AFTER = 'app_after',
    CONTEXT_BARGUN = 'bargun',
}
